/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AddTeamMappingsPayload,
  ApiLinkedEmployeeFilterRequest,
  ConflictsCountResponse,
  EmployeeIdsDto,
  EmployeeInfo,
  EmployeesPage,
  GetActiveEmployeesFilteredParams,
  GetActiveEmployeesParams,
  KomboAbsenceTypeListResponse,
  KomboAbsenceTypeSaveRequest,
  KomboConnectIntegrationResponse,
  KomboGroup,
  KomboIntegrationResponse,
  LinkDto,
  PaginatedResponseLinkedUserWithKomboInfoLinkedEmployeesPagedMeta,
  TeamMappingDto,
  TokenDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiKomboController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetActiveIntegrationByOrganisationId
   * @request GET:/api/v1/kombo/integration
   */
  getActiveIntegrationByOrganisationId = (params: RequestParams = {}) =>
    this.http.request<KomboIntegrationResponse, any>({
      path: `/v1/kombo/integration`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActiveIntegrationByOrganisationIdPath = '/v1/kombo/integration'
  static getActiveIntegrationByOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name ConnectIntegration
   * @request POST:/api/v1/kombo/integration
   */
  connectIntegration = (data: TokenDto, params: RequestParams = {}) =>
    this.http.request<KomboConnectIntegrationResponse, any>({
      path: `/v1/kombo/integration`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static connectIntegrationPath = '/v1/kombo/integration'
  static connectIntegrationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name DeactivateIntegration
   * @request DELETE:/api/v1/kombo/integration
   */
  deactivateIntegration = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/kombo/integration`,
      method: 'DELETE',
      ...params,
    })

  static deactivateIntegrationPath = '/v1/kombo/integration'
  static deactivateIntegrationMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetTeamMappings
   * @request GET:/api/v1/kombo/integration/team-mappings
   */
  getTeamMappings = (params: RequestParams = {}) =>
    this.http.request<TeamMappingDto[], any>({
      path: `/v1/kombo/integration/team-mappings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getTeamMappingsPath = '/v1/kombo/integration/team-mappings'
  static getTeamMappingsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name AddTeamMappings
   * @request POST:/api/v1/kombo/integration/team-mappings
   */
  addTeamMappings = (data: AddTeamMappingsPayload, params: RequestParams = {}) =>
    this.http.request<TeamMappingDto[], any>({
      path: `/v1/kombo/integration/team-mappings`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static addTeamMappingsPath = '/v1/kombo/integration/team-mappings'
  static addTeamMappingsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetMatchedEmployees
   * @request GET:/api/v1/kombo/integration/employees/matched
   */
  getMatchedEmployees = (params: RequestParams = {}) =>
    this.http.request<EmployeeInfo[], any>({
      path: `/v1/kombo/integration/employees/matched`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMatchedEmployeesPath = '/v1/kombo/integration/employees/matched'
  static getMatchedEmployeesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name LinkMatchedEmployees
   * @request POST:/api/v1/kombo/integration/employees/matched
   */
  linkMatchedEmployees = (params: RequestParams = {}) =>
    this.http.request<EmployeeInfo[], any>({
      path: `/v1/kombo/integration/employees/matched`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static linkMatchedEmployeesPath = '/v1/kombo/integration/employees/matched'
  static linkMatchedEmployeesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name InviteEmployees
   * @request POST:/api/v1/kombo/integration/employees/invite
   */
  inviteEmployees = (data: EmployeeIdsDto, params: RequestParams = {}) =>
    this.http.request<EmployeeInfo[], any>({
      path: `/v1/kombo/integration/employees/invite`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static inviteEmployeesPath = '/v1/kombo/integration/employees/invite'
  static inviteEmployeesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetLinkedInfoPaged
   * @request POST:/api/v1/kombo/integration/employee/linked-info/paged
   */
  getLinkedInfoPaged = (data: ApiLinkedEmployeeFilterRequest, params: RequestParams = {}) =>
    this.http.request<PaginatedResponseLinkedUserWithKomboInfoLinkedEmployeesPagedMeta, any>({
      path: `/v1/kombo/integration/employee/linked-info/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getLinkedInfoPagedPath = '/v1/kombo/integration/employee/linked-info/paged'
  static getLinkedInfoPagedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name ResolveAllConflicts
   * @request POST:/api/v1/kombo/integration/employee/linked-info/conflicts/resolve-all
   */
  resolveAllConflicts = (params: RequestParams = {}) =>
    this.http.request<ConflictsCountResponse, any>({
      path: `/v1/kombo/integration/employee/linked-info/conflicts/resolve-all`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static resolveAllConflictsPath =
    '/v1/kombo/integration/employee/linked-info/conflicts/resolve-all'
  static resolveAllConflictsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetAbsenceTypes
   * @request GET:/api/v1/kombo/integration/absence-types
   */
  getAbsenceTypes = (params: RequestParams = {}) =>
    this.http.request<KomboAbsenceTypeListResponse, any>({
      path: `/v1/kombo/integration/absence-types`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAbsenceTypesPath = '/v1/kombo/integration/absence-types'
  static getAbsenceTypesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name SaveAbsenceTypes
   * @request POST:/api/v1/kombo/integration/absence-types
   */
  saveAbsenceTypes = (data: KomboAbsenceTypeSaveRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/kombo/integration/absence-types`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static saveAbsenceTypesPath = '/v1/kombo/integration/absence-types'
  static saveAbsenceTypesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetKomboTeams
   * @request GET:/api/v1/kombo/integration/teams
   */
  getKomboTeams = (params: RequestParams = {}) =>
    this.http.request<KomboGroup[], any>({
      path: `/v1/kombo/integration/teams`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getKomboTeamsPath = '/v1/kombo/integration/teams'
  static getKomboTeamsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetActiveEmployees
   * @request GET:/api/v1/kombo/integration/employees/paged
   */
  getActiveEmployees = (query: GetActiveEmployeesParams, params: RequestParams = {}) =>
    this.http.request<EmployeesPage, any>({
      path: `/v1/kombo/integration/employees/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getActiveEmployeesPath = '/v1/kombo/integration/employees/paged'
  static getActiveEmployeesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetActiveEmployeesFiltered
   * @request GET:/api/v1/kombo/integration/employees/filtered
   */
  getActiveEmployeesFiltered = (
    query: GetActiveEmployeesFilteredParams,
    params: RequestParams = {},
  ) =>
    this.http.request<EmployeeInfo[], any>({
      path: `/v1/kombo/integration/employees/filtered`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getActiveEmployeesFilteredPath = '/v1/kombo/integration/employees/filtered'
  static getActiveEmployeesFilteredMethod = 'GET'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name GetConflictsCount
   * @request GET:/api/v1/kombo/integration/employee/linked-info/conflicts-count
   */
  getConflictsCount = (params: RequestParams = {}) =>
    this.http.request<ConflictsCountResponse, any>({
      path: `/v1/kombo/integration/employee/linked-info/conflicts-count`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getConflictsCountPath = '/v1/kombo/integration/employee/linked-info/conflicts-count'
  static getConflictsCountMethod = 'GET'
  /**
   * No description
   *
   * @tags api-kombo-controller
   * @name CreateKomboConnectFlowLink
   * @request GET:/api/v1/kombo/connect-flow-link
   */
  createKomboConnectFlowLink = (params: RequestParams = {}) =>
    this.http.request<LinkDto, any>({
      path: `/v1/kombo/connect-flow-link`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static createKomboConnectFlowLinkPath = '/v1/kombo/connect-flow-link'
  static createKomboConnectFlowLinkMethod = 'GET'
}
